namespace RedBullMOBILE360.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
